import { createSelector } from 'reselect';
import DespatchParticularsOverviewColumns from '../../containers/DespatchParticularsOverviewColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_PARTICULARS_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_PARTICULARS_OVERVIEW.isLoading;

export const getData = ReportsDefinition.DESPATCH_PARTICULARS_OVERVIEW.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsOverviewColumns);
